module.exports = __webpack_public_path__ + "img/banner.c5fd3949.webp";